


















import {Component, Prop, Vue} from 'vue-property-decorator';
import ClassificationButton from '@/modules/neovehicle/components/btn-classification.component.vue';

@Component({
  components: {
    ClassificationButton,
  },
})
export default class extends Vue {
  @Prop({ type: Boolean })
  public loading: boolean;

  @Prop({ type: Boolean, required: true })
  public value: boolean;

  public classifiedInternal!: boolean;

  public created() {
    this.classifiedInternal = this.value;
  }

  public handleClassification(value: boolean) {
    this.$emit('change-classification', value);
    this.$emit('input', value);
  }

  public handleDownload() {
    this.$emit('click-download');
  }
}
